import Api from './Api'
import Vue from 'vue'
import router from '../router/index'
import store from "../store/store"

const ToastTabError = { theme: 'toasted-primary', icon:'warning', position: 'top-center', duration: 4000, fitToScreen: true, type: 'error'}
const codePartenaire = store.state.code_partenaire;
export default function wavepayment(amount, numDevis){
    const data = {
        "amount": amount,
        "currency": "XOF",
        "client_reference":codePartenaire+"_"+numDevis.replace(/[/]/g, '_'),
        "error_url": "https://assuraf.com/payment/wave/?mdoi="+numDevis.replace(/[/]/g, '_'),    
        "success_url":"https://assuraf.com/payment/wave/?mdoi="+numDevis.replace(/[/]/g, '_')
    }
    Api().post("wave/create/session/",data)
    .then((result) => {
        if(result.data.id){
            window.open(result.data.wave_launch_url)
            setTimeout(() => {  router.go(router.push('/payment/wave/?mdoi='+numDevis.replace(/[/]/g, '_'))) }, 10000);
        }
    }).catch((err) => {
        console.log(err)
        Vue.toasted.show('Erreur de connexion serveur wave ! ', ToastTabError)
    });
}